import { Component, Input, OnInit, ViewChild } from '@angular/core';
import IProcessEventsSequenceAnalyzerStatistic = ZoningAPI.IProcessEventsSequenceAnalyzerStatistic;
import * as moment from 'moment';
import { DATETIME_FORMAT, getTime, millisecondsToSeconds } from '../../../../../../shared/utils/utils';
import { UpdateProcessEventsStatisticButtonComponent } from '../../buttons/update-process-events-statistic-button/update-process-events-statistic-button.component';

@Component({
    standalone: false,
    selector: 'app-events-stat-component',
    templateUrl: './events-stat-component.component.html',
    styleUrls: ['./events-stat-component.component.scss']
})
export class EventsStatComponentComponent implements OnInit {
    @Input()
    stateEnv: string;

    _statistic: IProcessEventsSequenceAnalyzerStatistic;

    get statistic(): IProcessEventsSequenceAnalyzerStatistic {
        return this._statistic;
    }

    @Input()
    set statistic(value: IProcessEventsSequenceAnalyzerStatistic) {
        this._statistic = value;
        this.initValues();
    }

    @Input()
    hideRefreshButton: boolean = false;

    @Input()
    showInColumn: boolean = false;

    @ViewChild(UpdateProcessEventsStatisticButtonComponent)
    eventsStatisticButton: UpdateProcessEventsStatisticButtonComponent;

    createdAtStr: string;
    deletedAtStr: string;
    finishedAtStr: string;
    lifeTimeStr: string;
    workTimeStr: string;
    waitingTimeStr: string;

    constructor() {}

    ngOnInit(): void {
        this.initValues();
    }

    updateStatistic(data: IProcessEventsSequenceAnalyzerStatistic) {
        if (!data) {
            return;
        }
        Object.assign(this.statistic, data);
        this.initValues();
    }

    initValues() {
        if (!this.statistic) {
            return;
        }

        this.createdAtStr = this.statistic?.createdAt ? moment(this.statistic.createdAt).format(DATETIME_FORMAT) : '';
        this.deletedAtStr = this.statistic?.deletedAt ? moment(this.statistic.deletedAt).format(DATETIME_FORMAT) : '';
        this.finishedAtStr = this.statistic?.finishedAt
            ? moment(this.statistic.finishedAt).format(DATETIME_FORMAT)
            : '';

        this.lifeTimeStr = getTime(millisecondsToSeconds(this.statistic?.lifeTimeMs));
        this.workTimeStr = getTime(millisecondsToSeconds(this.statistic?.workTimeMs));
        this.waitingTimeStr = getTime(millisecondsToSeconds(this.statistic?.waitingTimeMs));
    }

    runUpdate() {
        if (!this.eventsStatisticButton) {
            return;
        }
        this.eventsStatisticButton.updateProcessEventsStatistic().subscribe();
    }
}
